import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content", "icon"]

  toggle(event) {
    const button = event.currentTarget
    const content = button.nextElementSibling
    const icon = button.querySelector('[data-accordion-target="icon"]')
    
    if (content.classList.contains('hidden')) {
      // 開く
      content.classList.remove('hidden')
      icon.style.transform = 'rotate(180deg)'
      button.setAttribute('aria-expanded', 'true')
    } else {
      // 閉じる
      content.classList.add('hidden')
      icon.style.transform = 'rotate(0deg)'
      button.setAttribute('aria-expanded', 'false')
    }
  }
}
